import React, { useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MdMoreVert, MdArrowBack } from 'react-icons/md';
import Cookie from './Cookie/Cookie';
import Sidebar from './NewSidebar/Sidebar'
import style from './Layout.module.css'
import { CommunitySearchProvider } from './Context/CommunitySearchContext'
import { useActivityLog } from '../hooks/useActivityLog'

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useActivityLog();
  const isJobViewPage = location.pathname.startsWith('/job-view/');
  const isAddSkillsPage = location.pathname === '/profile/add-skills';
  const isEditSkillsPage = location.pathname === '/profile/edit-skills';
  const isEditSkillPage = location.pathname === '/profile/edit-skill';
  const isProfileDetailsPage = location.pathname === '/profile/profile-details' || location.pathname.startsWith('/profile/profile-details/');
  const isProfilePage = location.pathname === '/profile';
  const isLearningsPage = location.pathname === '/learnings';
  const isOpportunitiesPage = location.pathname === '/opportunities';
  const isRequestsPage = location.pathname === '/requests';
  const isEventDetailsPage = location.pathname.startsWith('/event/details');
  const isCommunityPage = location.pathname === '/community';
  const isNewLearningDetailPage = location.pathname === '/new/learnings/detail';
  const isPeerProfilePage = location.pathname === '/peerprofile';
  const isOffersPage = location.pathname === '/offers';
  const isSkillsPage = isAddSkillsPage || isEditSkillsPage || isEditSkillPage;
  const showBackButton = isSkillsPage;
  const isDashboardPage = location.pathname === '/';

  const [finishPopup, setFinishPopup] = useState(false);
  const [finished, setFinished] = useState(false);
  const [timeRunning, setTimeRunning] = useState(false);
  const [attended, setAttended] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [profileSlot, setProfileSlot] = useState(null)
  const [desktopProfileSlot, setDesktopProfileSlot] = useState(null)

  const handleMenuToggle = () => {
    setSidebarOpen((prev) => !prev)
  }

  const handleSidebarClose = () => {
    setSidebarOpen(false)
  }

  const handleBackNavigation = () => {
    if (isEditSkillPage) {
      navigate('/profile/edit-skills');
    } else {
      navigate('/profile');
    }
  }

  return (
    <CommunitySearchProvider>
      <div className={style.layoutContainer}>
        <div className={style.mainContent}>
          <div className={style.desktopProfileArea} ref={(el) => setDesktopProfileSlot(el)} />
          <Sidebar
            finished={finished}
            timeRunning={timeRunning}
            setFinishPopup={setFinishPopup}
            attended={attended}
            isOpen={sidebarOpen}
            onClose={handleSidebarClose}
            dashboardMode={true}
            onMenuToggle={handleMenuToggle}
            profileSlot={profileSlot}
            desktopProfileSlot={desktopProfileSlot}
          />
          {sidebarOpen && <div className={style.backdrop} onClick={handleSidebarClose} />}
          <div className={style.content}>
            {showBackButton && (
              <button
                type="button"
                className={style.desktopBackFloating}
                onClick={handleBackNavigation}
                aria-label="Go back"
              >
                <MdArrowBack size={20} />
              </button>
            )}
            <div className={`${style.pageContent} ${showBackButton ? style.pageContentWithFloatingActions : ''}`}>
              {!isProfileDetailsPage && !isProfilePage && !isLearningsPage && !isOpportunitiesPage && !isCommunityPage && !isDashboardPage && !isEventDetailsPage && !isOffersPage && !isPeerProfilePage && !isJobViewPage && location.pathname !== '/skills' && location.pathname !== '/skills/detail' && location.pathname !== '/lerning/detail' && !sidebarOpen && (
                <button
                  type="button"
                  className={`${style.mobileMenuPageBtn}${isNewLearningDetailPage ? ` ${style.mobileMenuPageBtnLearningDetail}` : ''}${isRequestsPage ? ` ${style.mobileMenuPageBtnRequests}` : ''}${isEventDetailsPage ? ` ${style.mobileMenuPageBtnEventDetails}` : ''}${isPeerProfilePage ? ` ${style.mobileMenuPageBtnPeerProfile}` : ''}${isOffersPage ? ` ${style.mobileMenuPageBtnOffers}` : ''}`}
                  onClick={handleMenuToggle}
                  aria-label="Open menu"
                >
                  <MdMoreVert size={isNewLearningDetailPage ? 22 : 24} />
                </button>
              )}
              <div className={style.outletStretch}>
                <Outlet
                  context={{
                    finishPopup,
                    setFinishPopup,
                    setTimeRunning,
                    finished,
                    setFinished,
                    timeRunning,
                    setAttended,
                    attended,
                    onMenuToggle: handleMenuToggle,
                    sidebarOpen,
                    setProfileSlot,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <Cookie />
      </div>
    </CommunitySearchProvider>
  )
}

export default Layout